import { render } from "./Curso.vue?vue&type=template&id=1ad46bae&lang=true"
import script from "./Curso.vue?vue&type=script&lang=js"
export * from "./Curso.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__